import Model from 'flarum/common/Model';
/**
 * A status or assignment change on a ticket, shown inline in its timeline.
 * `user` made the change; it is null when the forum did it (auto-close) or
 * the account has been deleted.
 */
export default class SupportEvent extends Model {
  type = (() => Model.attribute('type'))();
  fromStatus = (() => Model.attribute('fromStatus'))();
  toStatus = (() => Model.attribute('toStatus'))();
  hadAssignee = (() => Model.attribute('hadAssignee'))();
  hasAssignee = (() => Model.attribute('hasAssignee'))();
  isAutomatic = (() => Model.attribute('isAutomatic'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  fromUser = (() => Model.hasOne('fromUser'))();
  toUser = (() => Model.hasOne('toUser'))();
}
flarum.reg.add('linkrobins-support', 'common/models/SupportEvent', SupportEvent);